module.exports = __webpack_public_path__ + "static/history2-b16b3ab3855efe07a8a2c5034d9c4d24.png";